/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Observable } from 'rxjs';
import { requestAuthenticated, Optional, RequestOption, HttpHeaders, HttpQuery, throwIfNullOrUndefined, encodeURI } from '../runtime';
import {
    PageOfRESTItemComposed,
    PageOfRESTSharePointLibrary,
    RESTAsyncRestoreResponse,
    RESTExceptionInfo,
    RESTRestoreListConfig,
    RESTRestoreToListConfig,
    RESTSendAsMsgOptionsV6,
    RESTSharePointLibrary,
    RESTVESPSearchOptions,
} from '../models';

export interface SharePointLibraryApiSharePointLibraryGetRequest {
    restoreSessionId: string;
    siteId: string;
    offset: number;
    limit: number;
}

export interface SharePointLibraryApiSharePointLibraryGetByIdRequest {
    restoreSessionId: string;
    siteId: string;
    libraryId: string;
}

export interface SharePointLibraryApiSharePointLibraryRestoreLibraryActionRequest {
    restoreSessionId: string;
    siteId: string;
    libraryId: string;
    restRestoreConfig: RESTRestoreListConfig;
}

export interface SharePointLibraryApiSharePointLibraryRestoreLibraryActionToRequest {
    restoreSessionId: string;
    siteId: string;
    libraryId: string;
    restRestoreConfig: RESTRestoreToListConfig;
}

export interface SharePointLibraryApiSharePointLibrarySaveLibraryActionRequest {
    restoreSessionId: string;
    siteId: string;
    libraryId: string;
}

export interface SharePointLibraryApiSharePointLibrarySearchLibraryByOptionsRequest {
    restoreSessionId: string;
    siteId: string;
    libraryId: string;
    offset: number;
    limit: number;
    searchOptions: RESTVESPSearchOptions;
    setId?: string;
    itemType?: SharePointLibrarySearchLibraryByOptionsItemTypeEnum;
}

export interface SharePointLibraryApiSharePointLibrarySendLibraryActionRequest {
    restoreSessionId: string;
    siteId: string;
    libraryId: string;
    sendAsMsgOptions: RESTSendAsMsgOptionsV6;
}

/**
 * no description
 */
export const sharePointLibraryApi = ({

    /**
     * Returns a collection of backed-up SharePoint document libraries to explore and restore.
     * Get SharePoint Libraries
     */
    sharePointLibraryGet: ({ restoreSessionId, siteId, offset, limit }: SharePointLibraryApiSharePointLibraryGetRequest, option?: RequestOption): Observable<Optional<PageOfRESTSharePointLibrary>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'sharePointLibraryGet');
        throwIfNullOrUndefined(siteId, 'siteId', 'sharePointLibraryGet');
        throwIfNullOrUndefined(offset, 'offset', 'sharePointLibraryGet');
        throwIfNullOrUndefined(limit, 'limit', 'sharePointLibraryGet');

        const headers: HttpHeaders = {
        };

        const query: HttpQuery = { // required parameters are used directly since they are already checked by throwIfNullOrUndefined
            'offset': offset,
            'limit': limit,
        };

        return requestAuthenticated<PageOfRESTSharePointLibrary>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/Sites/{siteId}/Libraries'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{siteId}', encodeURI(siteId)),
            method: 'GET',
            headers,
            query,
        }, option);
    },

    /**
     * Returns a resource representation of a backed-up SharePoint document library with the specified ID.
     * Get SharePoint Library
     */
    sharePointLibraryGetById: ({ restoreSessionId, siteId, libraryId }: SharePointLibraryApiSharePointLibraryGetByIdRequest, option?: RequestOption): Observable<Optional<RESTSharePointLibrary>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'sharePointLibraryGetById');
        throwIfNullOrUndefined(siteId, 'siteId', 'sharePointLibraryGetById');
        throwIfNullOrUndefined(libraryId, 'libraryId', 'sharePointLibraryGetById');

        const headers: HttpHeaders = {
        };

        return requestAuthenticated<RESTSharePointLibrary>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/Sites/{siteId}/Libraries/{libraryId}'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{siteId}', encodeURI(siteId)).replace('{libraryId}', encodeURI(libraryId)),
            method: 'GET',
            headers,
        }, option);
    },

    /**
     * Restores a backed-up SharePoint document library with the specified ID to the original location.
     * Restore SharePoint Library to Original Location
     */
    sharePointLibraryRestoreLibraryAction: ({ restoreSessionId, siteId, libraryId, restRestoreConfig }: SharePointLibraryApiSharePointLibraryRestoreLibraryActionRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'sharePointLibraryRestoreLibraryAction');
        throwIfNullOrUndefined(siteId, 'siteId', 'sharePointLibraryRestoreLibraryAction');
        throwIfNullOrUndefined(libraryId, 'libraryId', 'sharePointLibraryRestoreLibraryAction');
        throwIfNullOrUndefined(restRestoreConfig, 'restRestoreConfig', 'sharePointLibraryRestoreLibraryAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/Sites/{siteId}/Libraries/{libraryId}/restore'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{siteId}', encodeURI(siteId)).replace('{libraryId}', encodeURI(libraryId)),
            method: 'POST',
            headers,
            body: restRestoreConfig,
        }, option);
    },

    /**
     * Restores a backed-up SharePoint document library with the specified ID to another location.
     * Restore SharePoint Library to Another Location
     */
    sharePointLibraryRestoreLibraryActionTo: ({ restoreSessionId, siteId, libraryId, restRestoreConfig }: SharePointLibraryApiSharePointLibraryRestoreLibraryActionToRequest, option?: RequestOption): Observable<Optional<RESTAsyncRestoreResponse>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'sharePointLibraryRestoreLibraryActionTo');
        throwIfNullOrUndefined(siteId, 'siteId', 'sharePointLibraryRestoreLibraryActionTo');
        throwIfNullOrUndefined(libraryId, 'libraryId', 'sharePointLibraryRestoreLibraryActionTo');
        throwIfNullOrUndefined(restRestoreConfig, 'restRestoreConfig', 'sharePointLibraryRestoreLibraryActionTo');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<RESTAsyncRestoreResponse>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/Sites/{siteId}/Libraries/{libraryId}/restoreTo'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{siteId}', encodeURI(siteId)).replace('{libraryId}', encodeURI(libraryId)),
            method: 'POST',
            headers,
            body: restRestoreConfig,
        }, option);
    },

    /**
     * Saves a backed-up SharePoint document library with the specified ID.  SharePoint document libraries are always saved in a ZIP archive. When you save a SharePoint document library, the request command archives the document library and places the ZIP archive in a temporary folder on the Veeam Backup for Microsoft 365 server. After that, the archive is transferred as application/octet-stream media to the client. To download, read or perform other actions with the octet-stream, use features of programming languages.  If downloading of the octet-stream was interrupted for some reason, you can send the request again and download the file from the temporary folder. 
     * Save SharePoint Library
     */
    sharePointLibrarySaveLibraryAction: ({ restoreSessionId, siteId, libraryId }: SharePointLibraryApiSharePointLibrarySaveLibraryActionRequest, option?: RequestOption): Observable<Optional<object>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'sharePointLibrarySaveLibraryAction');
        throwIfNullOrUndefined(siteId, 'siteId', 'sharePointLibrarySaveLibraryAction');
        throwIfNullOrUndefined(libraryId, 'libraryId', 'sharePointLibrarySaveLibraryAction');

        const headers: HttpHeaders = {
        };

        return requestAuthenticated<object>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/Sites/{siteId}/Libraries/{libraryId}/save'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{siteId}', encodeURI(siteId)).replace('{libraryId}', encodeURI(libraryId)),
            method: 'POST',
            headers,
        }, option);
    },

    /**
     * Searches for SharePoint documents in a backed-up SharePoint library with the specified ID.
     * Search for SharePoint Documents in SharePoint Library
     */
    sharePointLibrarySearchLibraryByOptions: ({ restoreSessionId, siteId, libraryId, offset, limit, searchOptions, setId, itemType }: SharePointLibraryApiSharePointLibrarySearchLibraryByOptionsRequest, option?: RequestOption): Observable<Optional<PageOfRESTItemComposed>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'sharePointLibrarySearchLibraryByOptions');
        throwIfNullOrUndefined(siteId, 'siteId', 'sharePointLibrarySearchLibraryByOptions');
        throwIfNullOrUndefined(libraryId, 'libraryId', 'sharePointLibrarySearchLibraryByOptions');
        throwIfNullOrUndefined(offset, 'offset', 'sharePointLibrarySearchLibraryByOptions');
        throwIfNullOrUndefined(limit, 'limit', 'sharePointLibrarySearchLibraryByOptions');
        throwIfNullOrUndefined(searchOptions, 'searchOptions', 'sharePointLibrarySearchLibraryByOptions');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        const query: HttpQuery = { // required parameters are used directly since they are already checked by throwIfNullOrUndefined
            'offset': offset,
            'limit': limit,
        };

        if (setId != null) { query['setId'] = setId; }
        if (itemType != null) { query['itemType'] = itemType; }

        return requestAuthenticated<PageOfRESTItemComposed>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/Sites/{siteId}/Libraries/{libraryId}/search'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{siteId}', encodeURI(siteId)).replace('{libraryId}', encodeURI(libraryId)),
            method: 'POST',
            headers,
            query,
            body: searchOptions,
        }, option);
    },

    /**
     * Sends a backed-up SharePoint document library with the specified ID as an attachment in an email message. <div class=\"note\"><strong>NOTE</strong> </br> To send items as attachments, you must specify the Veeam Explorer for Microsoft SharePoint email settings. For more information, see [Edit Email Settings](#tag/VespEmailSettings/operation/VespEmailSettings_Update). </div> 
     * Send SharePoint Library
     */
    sharePointLibrarySendLibraryAction: ({ restoreSessionId, siteId, libraryId, sendAsMsgOptions }: SharePointLibraryApiSharePointLibrarySendLibraryActionRequest, option?: RequestOption): Observable<Optional<void>> => {
        throwIfNullOrUndefined(restoreSessionId, 'restoreSessionId', 'sharePointLibrarySendLibraryAction');
        throwIfNullOrUndefined(siteId, 'siteId', 'sharePointLibrarySendLibraryAction');
        throwIfNullOrUndefined(libraryId, 'libraryId', 'sharePointLibrarySendLibraryAction');
        throwIfNullOrUndefined(sendAsMsgOptions, 'sendAsMsgOptions', 'sharePointLibrarySendLibraryAction');

        const headers: HttpHeaders = {
            'Content-Type': 'application/json',
        };

        return requestAuthenticated<void>({
            url: '/v8/RestoreSessions/{restoreSessionId}/Organization/Sites/{siteId}/Libraries/{libraryId}/send'.replace('{restoreSessionId}', encodeURI(restoreSessionId)).replace('{siteId}', encodeURI(siteId)).replace('{libraryId}', encodeURI(libraryId)),
            method: 'POST',
            headers,
            body: sendAsMsgOptions,
        }, option);
    },

})

/**
 * @export
 * @enum {string}
 */
export enum SharePointLibrarySearchLibraryByOptionsItemTypeEnum {
    All = 'All',
    Folders = 'Folders',
    Items = 'Items'
}
